var React = require('react');

function ContentInfoOpen (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M11.54.5C5.468.5.5 5.468.5 11.54c0 6.072 4.968 11.04 11.04 11.04 6.072 0 11.04-4.968 11.04-11.04C22.58 5.468 17.612.5 11.54.5zm0 20.01a8.952 8.952 0 0 1-8.97-8.97 8.952 8.952 0 0 1 8.97-8.97 8.952 8.952 0 0 1 8.97 8.97 8.952 8.952 0 0 1-8.97 8.97z","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"M10.16 10.16h2.76v6.9h-2.76z","key":1}),React.createElement("circle",{"cx":"11.54","cy":"7.4","r":"1.38","key":2})]));
}

ContentInfoOpen.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = ContentInfoOpen;

ContentInfoOpen.default = ContentInfoOpen;
